<template>
    <basic-card>
        <template slot="header">{{account.name}}</template>
        <template v-if="typeof accountBalances(account) != 'undefined' && accountBalances(account).length > 0">
            <div class="account-info">
                <trend
                        :data="balancesProjection"
                        :gradient="['white']" auto-draw
                        stroke-width="2px"
                        :width="100"
                        :height="30"

                />
                <h1>{{$formats.formatAmount(accountBalances(account)[0].endBalance / 100)}} {{account.currency}}</h1>
            </div>
        </template>
        <template v-else>
            <h1>0 {{account.currency}}</h1>
        </template>

    </basic-card>
</template>

<script>
    import BasicCard from "../components/layout/BasicCard";
    import {mapGetters} from "vuex";
    export default {
        name: "SingleAccountCard",
        components: {BasicCard},
        props: {
            account: Object
        },
        computed: {
            ... mapGetters({
                accountBalances: 'banking/accountBalances'
            }),
            balancesProjection() {
                if(typeof this.accountBalances(this.account) != 'undefined' && this.accountBalances(this.account).length > 0) {
                    return this.accountBalances(this.account).map(bal => bal.endBalance / 100);
                }
                else {
                    return new Array(5).map(() => 0);
                }

            }
        },
        data: function () {
            return {}
        }
    }
</script>

<style lang="scss" scoped>
@import "../styles/global";

    .account-info {
        display: flex;
        align-items: center;
        align-content: center;
        justify-content: center;
        justify-items: center;
        color: $navigationGray
    }
</style>